// Page-size options shared by every listing pagination dropdown.
export const PAGE_SIZE_OPTIONS = [
    { value: 10, text: '10 per page' },
    { value: 25, text: '25 per page' },
    { value: 50, text: '50 per page' },
    { value: 100, text: '100 per page' },
];
